module.exports = __webpack_public_path__ + "620137f122e5014adc402a6ab56d8dc2.glb";